var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { IdOutskirtBuildings } from "../constants/IdOutskirtBuildings";
import { IdLoca } from "../utils/i18n/IdLoca";
import { ReplacementLoca } from "../utils/i18n/ReplacementLoca";
import { selectOutskirtBuildingAccessible, selectOutskirtBuildingInfo, } from "./selectOutskirtBuildingInfo";
import { selectIsTutorialActive } from "./selectTutorial";
export var selectTooltipTextBuildingInfo = function (state) { return (__assign({}, state.tooltip.tooltipTextBuildingInfo)); };
export var selectAreTooltipHidden = function (state) {
    var tooltipHidden = !state.tooltip.visible;
    var tutorialActive = selectIsTutorialActive(state);
    return tooltipHidden || tutorialActive;
};
export var selectTooltipForOutskirtBuilding = function (state, outskirtId) {
    var notImplementedBuildings = [
        IdOutskirtBuildings.ExternalBarn,
        IdOutskirtBuildings.Cafe,
        IdOutskirtBuildings.Harbor,
        IdOutskirtBuildings.Pier,
    ];
    var isImplemented = notImplementedBuildings.indexOf(outskirtId) < 0;
    var isAccessible = selectOutskirtBuildingAccessible(state, outskirtId);
    var id = IdLoca.empty;
    var replacements = new Map();
    if (isImplemented) {
        var buildingInfo = selectOutskirtBuildingInfo(state, outskirtId);
        if (!isAccessible) {
            id = IdLoca.floatingText_levelCap;
            replacements.set(ReplacementLoca.zero_0, buildingInfo.balancing.unlockLevel.toString());
        }
        else {
            id = buildingInfo.balancing.locaKey;
        }
    }
    else {
        id = IdLoca.floatingText_featureNotAvailableYet;
    }
    return {
        id: id,
        replacements: replacements,
    };
};



//////////////////
// WEBPACK FOOTER
// ./src/selectors/selectTooltipInfo.ts
// module id = 878
// module chunks = 3